var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("img", {
    staticClass: "logo",
    attrs: {
      src: require(`@/assets/images/logos/${_vm.logoName(_vm.theme)}.webp`),
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }